module.exports = __webpack_public_path__ + "img/img_success.a54b15c9.png";